import axios from '@/axios'
import * as types from '../mutation-types'

export default {
	namespaced: true,

	state: {
		users: []
	},

	actions: {
		fetchAll({ commit }) {
			return axios.get('/user/all').then(data => {
				commit(types.STORE_ROLES, data);
				return data;
			})
		},

		fetchById({ commit }, { id }) {
			return axios.get(`/user/${id}`)
		},

		create({ commit }, { userName, password, roleId }) {
			return axios.post('/user', { email: 'bee@bee.com', userName, password, roleId, isActive: true })
		},

		update({ commit }, { id, userName, password, roleId }) {
			return axios.put(`/user/${id}`, { email: 'bee@bee.com', newUsername: userName, newPassword: password, roleId })
		},

		updateState({ commit }, { id }) {
			return axios.put(`/user/${id}/toggle`)
		},

		delete({ commit }, { id }) {
			return axios.delete(`/user/${id}`)
		},

		reset({ commit }) {
			commit(types.RESET);
		}
	},

	mutations: {
		[types.STORE_ROLES](state, users) {
			state.users = users;
		},
		[types.RESET](state) {
			state.users = [];
		}
	},

	getters: {
		getRoleById: state => id => state.roles.find(c => c.id === id)
	}
}